// Tiny client-side CSV header sniffer for the importer's column-mapping UI
// (BUILD_SPEC.md §5.9, §2.13). Deliberately NOT a full CSV parser — the
// server's own `csv-parse`-backed parser (services/api/src/modules/importer/
// csv.ts) is the authoritative one, exercised at `/validate`; this only reads
// the header line well enough to let an operator build an optional column
// mapping before submitting.
export function sniffCsvHeaders(csvContent: string): string[] {
  const firstLine = csvContent.split(/\r?\n/).find((line) => line.trim().length > 0);
  if (!firstLine) return [];

  const headers: string[] = [];
  let current = '';
  let inQuotes = false;
  for (const ch of firstLine) {
    if (ch === '"') {
      inQuotes = !inQuotes;
      continue;
    }
    if (ch === ',' && !inQuotes) {
      headers.push(current.trim());
      current = '';
      continue;
    }
    current += ch;
  }
  headers.push(current.trim());
  return headers.filter((h) => h.length > 0);
}

/** Target field names each import kind's row schema accepts (mirrors
 * services/api/src/modules/importer/rows.ts's per-kind coercion — that file is
 * server-only, so this list is duplicated here for the UI's mapping picker;
 * the server's own zod schema is what actually validates at `/validate`, this
 * is purely a data-entry aid). */
export const IMPORT_TARGET_FIELDS: Record<string, string[]> = {
  PRODUCTS: [
    'sku',
    'name',
    'type',
    'baseUom',
    'isMoistureTracked',
    'defaultMcPct',
    'bulkDensityKgM3',
    'vatTreatment',
    'minLevel',
    'reorderQty',
    'xeroSalesAccount',
    'xeroPurchaseAccount',
    'isActive',
  ],
  SUPPLIERS: ['code', 'name', 'vatNumber', 'email', 'phone', 'paymentTerms', 'xeroContactId', 'isActive'],
  CUSTOMERS: [
    'code',
    'name',
    'vatNumber',
    'email',
    'deliveryAddress',
    'paymentTerms',
    'invoicingMode',
    'consolidationPeriod',
    'xeroContactId',
    'isActive',
  ],
  OPENING_BALANCES: ['sku', 'locationCode', 'qty', 'mcPct', 'unitCostCents'],
  // Customer/from-location/period are job-level PARAMS (picked once, not per
  // CSV row) — see ImportJobWizard.tsx's FBA_SALES extra fields.
  FBA_SALES: ['sku', 'qty', 'revenue', 'date'],
};
